module.exports = __webpack_public_path__ + "7820801fe0a2ad581f8616622d776725.jpg";